<template>
  <CSidebar
    position="fixed"
    :unfoldable="sidebarUnfoldable"
    :visible="sidebarVisible"
    @visible-change="
      (event) =>
        $store.commit({
          type: 'updateSidebarVisible',
          value: event,
        })
    "
  >
    <CSidebarBrand>
      <CIcon
        custom-class-name="sidebar-brand-full"
        :icon="logoNegative"
        :height="35"
      />
      <CIcon
        custom-class-name="sidebar-brand-narrow"
        :icon="sygnet"
        :height="35"
      />
    </CSidebarBrand>
    <AppSidebarNav />
    <div v-if="user?.admin" class="c-sidebar-nav-item">
      <a style="margin-left: 30px;">
        <CIcon :icon="cilPeople"/>
        Total Clientes: {{customers}} 
      </a>
    </div>
    <CSidebarToggler
      class="d-none d-lg-flex"
      @click="$store.commit('toggleUnfoldable')"
    />
  </CSidebar>
</template>

<script>
import { computed } from 'vue'
import { useStore } from 'vuex'
import { AppSidebarNav } from './AppSidebarNav'
import { logoNegative } from '@/assets/brand/logo-negative'
import { sygnet } from '@/assets/brand/sygnet'
import { cilPeople } from '@coreui/icons';
import { useUserStore } from '@/plugins/store';
import axios from 'axios'

export default {
  name: 'AppSidebar',
  components: {
    AppSidebarNav,

  },
  data(){
    return {
      customers: 0
    }
  },
  setup() {
    const userStore = useUserStore();
    const user = userStore.getUser
    const store = useStore()
    return {
      user,
      cilPeople,
      logoNegative,
      sygnet,
      sidebarUnfoldable: computed(() => store.state.sidebarUnfoldable),
      sidebarVisible: computed(() => store.state.sidebarVisible),
    }
  },
  mounted(){
    this.getCustomersUnits()
  },
  methods:{
    getCustomersUnits(){
      axios
      .get('v1/customers/all_units')
      .then(res => {
        this.customers = res.data.length
      })
      .catch(err => console.log(err));
    },
  }
}
</script>
